<template>
  <v-row density="compact">
    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.term"
        :items="ma_days"
        label="EMA Days"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('term', $event)"
      />
    </v-col>

    <v-col cols="12" sm="12">
      <v-select
        :model-value="rule.config.above_below"
        :items="items"
        label="action"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('above_below', $event)"
      />
    </v-col>
    <v-col
      v-if="
        ['above', 'below', 'crossed above', 'crossed below'].indexOf(rule.config.above_below) >= 0
      "
      cols="12"
      sm="12"
    >
      <v-select
        :model-value="rule.config.comparison"
        :items="comparisons"
        label="compare to"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('comparison', $event)"
      />
    </v-col>
    <v-col
      v-if="
        ['above', 'below', 'crossed above', 'crossed below'].indexOf(rule.config.above_below) >= 0
      "
      cols="12"
      sm="12"
    >
      <v-select
        :model-value="rule.config.term2"
        :items="ma_days"
        label="Comparison Days"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('term2', $event)"
      />
    </v-col>

    <v-col
      v-if="
        rule.config.above_below == 'trending up last XX days' ||
        rule.config.above_below == 'trending down last XX days'
      "
      cols="12"
      sm="12"
    >
      <v-text-field
        :model-value="rule.config.days"
        density="compact"
        hide-details
        variant="outlined"
        label="Trending # days"
        @update:model-value="updateConfig('days', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  components: {},
  props: {
    rule: { type: Object, required: true }
  },
  emits: ['update:rule'],
  data() {
    return {
      items: [
        'above',
        'below',
        'crossed above',
        'crossed below',
        'trending up last XX days',
        'trending down last XX days'
      ],
      editedTa: {
        enabled: true,
        above_below: 'above',
        term: 12,
        term2: 26,
        comparison: 'EMA',
        rule_type: 'ema',
        threshold: 0,
        threshold_max: 100,
        days: 5,
        long_short: 'long'
      },
      defaultTa: {
        enabled: true,
        above_below: 'above',
        term: 12,
        term2: 26,
        comparison: 'EMA',
        rule_type: 'ema',
        threshold: 0,
        threshold_max: 100,
        days: 5,
        long_short: 'long'
      },
      ma_days: [],
      comparisons: ['SMA', 'EMA']
    }
  },

  computed: {
    ...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.trend_signal',
      enabled: 'app.whaleTraderCriteria.signals.trend_signal.enabled',
      signalView: 'app.signalView',
      exit_time_periods: 'app.exit_time_periods'
    })
  },

  watch: {},

  mounted() {
    this.ma_days = []
    for (var i = 2; i < 71; i++) {
      this.ma_days.push(i)
    }
    for (i = 75; i < 301; i += 5) {
      this.ma_days.push(i)
    }
    if (!this.rule.config || !this.rule.config.rule_type || this.rule.trend != 'ema') {
      this.$emit('update:rule', { ...this.rule, config: Object.assign({}, this.defaultTa) })
    }
  },

  methods: {
    updateConfig(key, value) {
      this.$emit('update:rule', { ...this.rule, config: { ...this.rule.config, [key]: value } })
    }
  }
}
</script>
